import { Action } from 'kbar';
import { designTokens } from 'theme';

type SectionedAction = Action & { section?: string };

function normalizeSearchText(value: string): string {
  return value.trim().toLowerCase();
}

function tokenizeSearchQuery(query: string): string[] {
  return normalizeSearchText(query).split(/\s+/).filter(Boolean);
}

function buildActionSearchText(action: SectionedAction): string {
  return normalizeSearchText([action.name, action.keywords].filter(Boolean).join(' '));
}

export function matchesKbarSearch(action: SectionedAction, query: string): boolean {
  const tokens = tokenizeSearchQuery(query);
  if (tokens.length === 0) {
    return true;
  }

  const haystack = buildActionSearchText(action);
  return tokens.every((token) => haystack.includes(token));
}

export function buildOrderedKbarResults(
  actions: SectionedAction[],
  query: string,
): Array<string | Action> {
  const filteredActions = actions.filter((action) => matchesKbarSearch(action, query));
  const results: Array<string | Action> = [];
  let currentSection: string | null = null;

  filteredActions.forEach((action) => {
    const section = action.section ?? '';
    if (section && section !== currentSection) {
      results.push(section);
      currentSection = section;
    }
    results.push(action);
  });

  return results;
}

export function getKbarSectionHeaderSx(isFirstSection: boolean): Record<string, unknown> {
  return {
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    minHeight: 48,
    fontSize: designTokens.typography.fontSize.sm,
    fontWeight: designTokens.typography.fontWeight.bold,
    fontFamily: designTokens.typography.fontMono,
    color: designTokens.colors.text.muted,
    textTransform: 'none',
    letterSpacing: '0.5px',
    lineHeight: 1.2,
    px: 2,
    pt: isFirstSection ? 1 : 1.5,
    pb: 1,
    mt: isFirstSection ? 0 : 0.5,
    borderTop: isFirstSection ? 'none' : `1px solid ${designTokens.menu.divider}`,
  };
}
